/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DiagnosisLetters/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import GenerateLettersModal from 'DesignSystem/GenerateLettersModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DiagnosisLetters({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Secondary/DiagnosisAction/Content/Diagnosis/DiagnosisLetters"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let eventAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.id',
})
let eventAppointmentBookingIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.id',
})
let generateLettersLettersValueData = fromData.useDataValue({ viewPath,
context: 'generate_letters',
path: 'letters',
})
let generateLettersDiagnosisIdValueData = fromData.useDataValue({ viewPath,
context: 'generate_letters',
path: 'diagnosis_id',
})
let generateLettersToothChartSnapshotIdValueData = fromData.useDataValue({ viewPath,
context: 'generate_letters',
path: 'tooth_chart_snapshot_id',
})
let generateLettersToothMarkingIdsValueData = fromData.useDataValue({ viewPath,
context: 'generate_letters',
path: 'tooth_marking_ids',
})
  return (<React.Fragment
>
<GenerateLettersModal
  viewPath={`${viewPath}/GenerateLettersModal`}
 data="patient._id"
 patientId={patientIdValueData}
 data="event.appointment.id"
 appointmentId={eventAppointmentIdValueData}
 data="event.appointment.booking.id"
 bookingId={eventAppointmentBookingIdValueData}
 data="generate_letters.letters"
 letters={generateLettersLettersValueData}
 data="generate_letters.diagnosis_id"
 diagnosisId={generateLettersDiagnosisIdValueData}
 data="generate_letters.tooth_chart_snapshot_id"
 toothChartSnapshotId={generateLettersToothChartSnapshotIdValueData}
 data="generate_letters.tooth_marking_ids"
 toothMarkingIds={generateLettersToothMarkingIdsValueData}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
{children}
</React.Fragment>)
}